import { ThemeProvider, createTheme } from "@mui/material/styles";
import { ptBR } from "@mui/material/locale";
import { DataGrid } from "@mui/x-data-grid";
import { Stack, Tooltip } from "@mui/material";

const theme = createTheme(ptBR);

const renderCellWithTooltip = (params: any) => {
    const value = params.formattedValue ?? params.value;
    const text = value === null || value === undefined ? "" : String(value);
    return (
        <Tooltip title={text}>
            <span
                style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {text}
            </span>
        </Tooltip>
    );
};

export interface IProps {
    columns: any;
    rows: any[];
    rowId: any;
    isLoading?: boolean;
    initialState?: any;
    checkboxSelection?: boolean;
    onRowSelectionModelChange?: any;
    rowSelectionModel?: any;
    hideFooter?: boolean;
}

export default function DataTable(props: IProps) {
    const columnsWithTooltip = (props.columns ?? []).map((column: any) =>
        column.renderCell || column.type === "actions"
            ? column
            : { ...column, renderCell: renderCellWithTooltip }
    );

    return (
        <ThemeProvider theme={theme}>
            <DataGrid
                columns={columnsWithTooltip}
                rows={props.rows}
                getRowId={props.rowId}
                loading={props.isLoading}
                checkboxSelection={props.checkboxSelection}
                onRowSelectionModelChange={props.onRowSelectionModelChange}
                rowSelectionModel={props.rowSelectionModel}
                hideFooter={props.hideFooter}
                rowsPerPageOptions={[10, 25, 50, 100]}
                pagination
                localeText={{
                    columnHeaderSortIconLabel: "Ordenar",
                    footerRowSelected: (count) =>
                        count > 1 ? `${count} linhas selecionadas` : `${count} linha selecionada`,
                }}
                components={{
                    NoResultsOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                            Nenhum resultado encontrado!
                        </Stack>
                    ),
                    NoRowsOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                            Nenhum registro
                        </Stack>
                    ),
                }}
            />
        </ThemeProvider>
    );
}
